import { Injectable } from '@angular/core';
import {environment} from "../environments/environment";
import {WmHttpService} from "@wms/services";

@Injectable({
  providedIn: 'root'
})
export class ProjectShellService {
  TARGET = "ProjectShell";
  API_META = {
    list: {
      url: environment.SERVICES_BASE_PATH + "services/projectShells",
      method: "GET"
    },
    remove: {
      url: environment.SERVICES_BASE_PATH + "services/projectShells/:projectShellID/versions/:versionId",
      method: "DELETE"
    }
  }

  constructor(private wmHttpService: WmHttpService) {
    wmHttpService.registerApiMeta(this.TARGET, this.API_META)
  }

  list(headers?:any): Promise<any> {
    return (this.wmHttpService.execute({
      target:this.TARGET,
      action:'list',
      headers: headers
    }) as Promise<any>)
  }


}
